import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useAppSelector } from 'store';
import { useGetUserInfoQuery } from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';

export const useCheckStoreHasSelectedPlan = () => {
  const { currentStore, role_id, loggedIn } = useAppSelector(userDetailsState);
  const { data: userInfo } = useGetUserInfoQuery(undefined, {
    skip: !loggedIn,
  });
  const history = useHistory();

  const isUserTreslAdmin = role_id === 1;

  useEffect(() => {
    if (!currentStore || !userInfo || isUserTreslAdmin) return;

    const hasCurrentStoreSelectedPlan = userInfo.onboard_objectives.find(
      (store) => store.store_name === currentStore.completeInfo?.store_name
    )?.plan_selected;

    const allowedPathnames = [
      'onboarding',
      'integrations/shopify',
      'account',
      '/dashboard/welcome',
    ];

    const isAllowedPathname = allowedPathnames.some((substring) =>
      history.location.pathname.includes(substring)
    );

    if (hasCurrentStoreSelectedPlan !== true && !isAllowedPathname) {
      history.replace({ ...history.location, pathname: '/onboarding' });
    }
  }, [
    currentStore,
    history,
    history.location.pathname,
    isUserTreslAdmin,
    userInfo,
  ]);
};
